import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { MAX_TITLE_LENGTH, TRUNCATE_SUFFIX } from './SameCase';
import { DecisionNotInDatabase } from './index';
import ClickableEntry from '@components/Timeline/ClickableEntry';
import { TimelinePositioningProps } from '@components/Timeline/types';
import { formatDateFromUnixTime } from '@utils/date';

interface SameCaseNotInDatabaseProps extends TimelinePositioningProps {
    decision: DecisionNotInDatabase;
}

const SameCaseNotInDatabase: FC<SameCaseNotInDatabaseProps> = ({
    decision,
    ...timelinePositioningProps
}) => {
    const { lang } = useTranslation('decision');
    const { date } = decision;
    let { title } = decision;
    if (title.length > MAX_TITLE_LENGTH)
        title = `${title.slice(0, MAX_TITLE_LENGTH)}${TRUNCATE_SUFFIX}`;
    const performedAtDate = date ? formatDateFromUnixTime(date.getTime() / 1000, lang) : '';

    return (
        <ClickableEntry
            content={performedAtDate}
            title={title}
            disabled
            {...timelinePositioningProps}
        />
    );
};

export default SameCaseNotInDatabase;
